import styled, { css } from 'styled-components';

export const TableBodyItem = styled.tr`
  transition: all 0.2s ease;

  td {
    text-align: left;
    border-bottom: 1px dotted #c9d3dd;
    padding: 10px;

    a,
    span {
      width: 100%;
      height: 100%;
    }

    :nth-child(1) {
      width: 5%;
      text-align: center;
      font-weight: bold;

      border-left: 4px solid #c9d3dd;
      border-radius: 3px;

      ${(props) =>
        props.past &&
        css`
          border-left: 4px solid #f43e61;
          border-radius: 3px;
        `}

      ${(props) =>
        props.received &&
        css`
          border-left: 4px solid #4ab858;
          border-radius: 3px;
        `}
    }
    :nth-child(2) {
      width: 10%;
      text-align: left;
    }
    :nth-child(3) {
      width: 15%;
      text-align: right;
    }

    :nth-child(4) {
      width: 15%;
      text-align: right;
      font-weight: bold;
    }
    :nth-child(5) {
      width: 20%;
      text-align: left;
      font-weight: bold;
    }
    :nth-child(6) {
      width: 0%;
      display: none;
    }
    :nth-child(7) {
      width: 0%;
    }
    :nth-child(8) {
      width: 0%;
    }
    :nth-child(9) {
      margin-right: auto;
      border-right: 1px dotted #c9d3dd;
    }

    :nth-child(10) {
      border-right: 1px dotted #c9d3dd;
    }
  }

  :hover {
    background: #fff;
  }
`;

export const Actions = styled.button`
  border: 0;
  background: transparent;
  margin: 0;
  padding: 8px 16px;

  svg {
    margin: 0;
  }
`;
